import NavSettings from "../../components/common/NavSettings";
import Documents from "../../components/Settings/Documents";

const DocumentsSettings = () => {
  return (
    <>
      <NavSettings title="Mi perfil" route="Inicio" active="Documentos" />

      <Documents />
    </>
  );
};

export default DocumentsSettings;
